import { getData } from "../axios";

export const getTherapist = async (userId) => {
  try {
    const res = await getData(
      `${process.env.NEXT_PUBLIC_NEW_USER_URL}therapist/${userId}`
    );
    return res;
  } catch (error) {
    console.error("error in getProfileById", JSON.stringify(error));
    throw new Error(error);
  }
};
